var nb = require('../../nb');
var util = require('../../util');
var shopCartItem = require('../../view/header/ShopCartMenu').ShopCartItem;
module.exports = nb.define({
    parent: nb.Model,
    mapping: {
        shopCartList: nb.model.List
    },
    method: {
        init: function () {
            this.onChange('data', function (inEvent) {
                var items = inEvent.data.items;
                var totalPrice = inEvent.data.summary.disAmounts;
                $.each(items, function (inIndex, inItem) {
                    var imgUrl = inItem.imgUrl;
                    inItem.price = util.numberFormat(inItem.disPrice / 100);
                    // inItem.price = "￥" + inItem.disPrice/100;
                    inItem.imgUrl = imgUrl + "?x-image-process=image/resize,m_pad,h_500,w_500,color_FFFFFF";
                    inItem.detailHref = "detail.html?id=" + inItem.spuId + 'skuId' + inItem.skuId;
                });
                if (inEvent.data.count > 0) {
                    this.set('status', 'have');
                }
                this.set('totalPrice', "￥" + util.numberFormat(totalPrice / 100)); //函数传参totalPrice
                // this.set('totalPrice',"￥"+totalPrice/100); //函数传参totalPrice
                this.set('shopCartList', {
                    itemType: shopCartItem,
                    items: items
                });
            }, this);
            this.onChange('requestTotalPrice', function (inEvent) {
                this.set('totalPrice', "￥" + util.numberFormat(inEvent.data.totalAmounts / 100));
                // this.set('totalPrice',"￥"+inEvent.data.totalAmounts/100);
            }, this);
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ../src/js/model/header/ShopCartMenu.js
// module id = 38
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32